// @ts-nocheck
import React from 'react';
import { Alert, Button } from 'antd';
import { ExclamationCircleOutlined, ReloadOutlined } from '@ant-design/icons';

interface AuthAlertProps {
  visible: boolean;
  onDismiss: () => void;
  onRetry?: () => void;
}

export function AuthAlert({ visible, onDismiss, onRetry }: AuthAlertProps) {
  if (!visible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 p-4">
      <Alert
        message="Problème d'authentification"
        description="Il y a un problème réseau et vous devez vous réauthentifier. Veuillez vous reconnecter pour continuer."
        type="error"
        showIcon
        icon={<ExclamationCircleOutlined />}
        action={
          <div className="flex gap-2">
            {onRetry && (
              <Button size="small" onClick={onRetry} icon={<ReloadOutlined />}>
                Réessayer
              </Button>
            )}
            <Button size="small" onClick={onDismiss}>
              Fermer
            </Button>
          </div>
        }
        onClose={onDismiss}
        className="shadow-lg"
      />
    </div>
  );
}
